import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';

import FollowGoalActionQuery from './__generated__/FollowGoalActionQuery.graphql';
import { FollowGoalActionQuery as FollowGoalActionQueryType } from './__generated__/FollowGoalActionQuery.graphql';

export const followGoalResource: RouteResource<
	PreloadedQuery<FollowGoalActionQueryType, Record<string, unknown>>
> = createRelayResource<FollowGoalActionQueryType>({
	getQuery: (routerContext) => {
		const { key } = routerContext?.match?.params || {};
		return {
			query: FollowGoalActionQuery,
			variables: {
				key: key || '',
			},
		};
	},
});
